<template>
  <div class="contact-list" v-if="nb_contacts">
    <div v-for="(contact, contact_idx) in contacts_of_lead" :keys="'contact-' + contact_idx">
      <contact @delete-contact="$emit('remove-contact', $event)" :contact="contact" :lead_id="lead_id"></contact>
      <hr v-if="contact_idx < current_contacts.length - 1">
    </div>
  </div>
  <div class="contact-list" v-else style="padding-left:20px">
    Ce lead n'a aucun contact pour le moment.
  </div>
</template>
<script>
import Contact from "./Contact"
import {mapGetters, mapActions, mapState} from "vuex"

export default {
  name:"Contacts",
  props:["lead_id"],
  components:{
    Contact
  },
  data() {
    return {
      current_contacts:[]
    }
  },

  computed:{
    ...mapGetters("crm", [
        "is_fetching",
        // "contacts",
        "page_of_leads",
        // "contacts_of_lead"
    ]),
    ...mapState("crm", ["currently_consulted_lead"]),

    nb_contacts() {
      // var exists = _.find(this.current_lead.contacts, ctc => ctc.lead_id == this.lead_id)
      // if (exists != undefined)
      if (this.currently_consulted_lead)
        return this.currently_consulted_lead.contacts.length
      else
        return 0
    },

    contacts_of_lead() {
      return this.currently_consulted_lead.contacts
    },
  },

}
</script>
<style scoped>
.contact-list {
  padding:20px;
}

</style>



// WEBPACK FOOTER //
// client/components/CRM/Contacts.vue